/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleCancelResponse
 */
export interface VehicleCancelResponse {
    /**
     * 
     * @type {string}
     * @memberof VehicleCancelResponse
     */
    status: VehicleCancelResponseStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof VehicleCancelResponse
     */
    cancelledAt?: Date;
}


/**
 * @export
 */
export const VehicleCancelResponseStatusEnum = {
    Success: 'success',
    NotFound: 'not found',
    AlreadyCancelled: 'already cancelled',
    CancellationFailed: 'cancellation failed'
} as const;
export type VehicleCancelResponseStatusEnum = typeof VehicleCancelResponseStatusEnum[keyof typeof VehicleCancelResponseStatusEnum];


/**
 * Check if a given object implements the VehicleCancelResponse interface.
 */
export function instanceOfVehicleCancelResponse(value: object): value is VehicleCancelResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function VehicleCancelResponseFromJSON(json: any): VehicleCancelResponse {
    return VehicleCancelResponseFromJSONTyped(json, false);
}

export function VehicleCancelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleCancelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'cancelledAt': json['cancelled_at'] == null ? undefined : (new Date(json['cancelled_at'])),
    };
}

export function VehicleCancelResponseToJSON(json: any): VehicleCancelResponse {
    return VehicleCancelResponseToJSONTyped(json, false);
}

export function VehicleCancelResponseToJSONTyped(value?: VehicleCancelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'cancelled_at': value['cancelledAt'] == null ? value['cancelledAt'] : value['cancelledAt'].toISOString(),
    };
}

